module.exports = __webpack_public_path__ + "static/media/21.b920e84e.jpg";